/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_updateBeneficiaryTravelBookingStatusRequest = {
    travel_booking_status: api_updateBeneficiaryTravelBookingStatusRequest.travel_booking_status;
};
export namespace api_updateBeneficiaryTravelBookingStatusRequest {
    export enum travel_booking_status {
        PROVIDER = 'provider',
        OWN = 'own',
    }
}

